import { render, staticRenderFns } from "./catalogDialog.vue?vue&type=template&id=79456d03&"
import script from "./catalogDialog.vue?vue&type=script&lang=ts&"
export * from "./catalogDialog.vue?vue&type=script&lang=ts&"
import style0 from "./catalogDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports